export default {
  alreadyHaveBackbox: {
    id: 'buyback_refurbisher_create_product_quotations_already_have_backbox',
    defaultMessage: 'You already have the BackBox',
  },
  alreadyHaveAllBackbox: {
    id: 'buyback_refurbisher_create_product_quotations_already_have_all_backboxes',
    defaultMessage: 'You already have all the BackBox',
  },
  createListingTitle: {
    id: 'buyback_refurbisher_create_product_quotations_breadcrumb',
    defaultMessage: 'Create Listing',
  },
  productId: {
    id: 'buyback_refurbisher_create_product_quotations_product_id',
    defaultMessage: 'Product Id: {productId}',
  },
  marketTitle: {
    id: 'buyback_refurbisher_create_product_quotations_markets_title',
    defaultMessage: 'Market',
  },
  grade: {
    id: 'buyback_refurbisher_create_product_quotations_grade',
    defaultMessage: 'Grade',
  },
  backboxPrice: {
    id: 'buyback_refurbisher_create_product_quotations_backbox_price',
    defaultMessage: 'BackBox price',
  },
  yourPrice: {
    id: 'buyback_refurbisher_create_product_quotations_price',
    defaultMessage: 'Your price',
  },
  sku: {
    id: 'buyback_refurbisher_create_product_quotations_sku',
    defaultMessage: 'SKU',
  },
  getAllBackboxes: {
    id: 'buyback_refurbisher_create_product_quotations_backboxes',
    defaultMessage: 'Get all BackBoxes',
  },
  getBackbox: {
    id: 'buyback_refurbisher_create_product_quotations_backbox',
    defaultMessage: 'Get BackBox',
  },
  priceInputLabel: {
    id: 'buyback_refurbisher_listing_price_input_label',
    defaultMessage: 'Price ({currency})',
  },
  saveListing: {
    id: 'buyback_refurbisher_create_product_quotations_save_listing',
    defaultMessage: 'Save listing',
  },
  saveListingCreate: {
    id: 'buyback_refurbisher_create_product_quotations_save_listing_create',
    defaultMessage: 'Save listing and create a new one',
  },
  saveListingCreateMobile: {
    id: 'buyback_refurbisher_create_product_quotations_save_listing_create_mobile',
    defaultMessage: 'Save, create new',
  },
  toastTitle: {
    id: 'buyback_refurbisher_create_product_quotations_toast_title',
    defaultMessage: 'Listing saved',
  },
  priceTitle: {
    id: 'buyback_refurbisher_create_product_quotations_price_title',
    defaultMessage: 'Price',
  },
  priceToWinBackboxTitle: {
    id: 'buyback_quotes_price_to_win_title',
    defaultMessage: 'Price to win BackBox',
  },
  priceToWinBackboxTooltip: {
    id: 'buyback_quotes_price_to_win_tooltip',
    defaultMessage: 'This price is influenced by your trade-in quality KPIs',
  },
  breadcrumb: {
    id: 'breadcrumb_aria_label',
    defaultMessage: 'Breadcrumb',
  },
  toastTimeoutTitle: {
    id: 'buyback_quotes_timeout_toast_title',
    defaultMessage: 'Loading... this could take a sec',
  },
  toastTimeoutContent: {
    id: 'buyback_quotes_timeout_toast_content',
    defaultMessage: 'Refresh the page to view prices faster.',
  },
}
